import { WorkerAction } from '../framework/workerAction';

export default {
  columns: {
    update: new WorkerAction({ name: 'front.campaignsTable.columns.update' }, {}),
    reset: new WorkerAction({ name: 'front.campaignsTable.columns.reset' }, {}),
  },
};
